var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAryaProPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 411.06 134.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#232326;}.cls-3{fill:#fff;}.cls-4{fill:#d32d28;}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1972.14,
    y1: -3317.85,
    x2: -1971.14,
    y2: -3317.85,
    gradientTransform: "translate(-160794.93 632121.54) rotate(45) scale(168.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d32d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#d32d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#d32d28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8e292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e292a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1972.14,
    y1: -3317.73,
    x2: -1971.14,
    y2: -3317.73,
    gradientTransform: "translate(-160794.93 632121.54) rotate(45) scale(168.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1bbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#f1bbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f1bbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#dbbabb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbbabb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -1972.14,
    y1: -3317.73,
    x2: -1971.14,
    y2: -3317.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -1972.14,
    y1: -3317.73,
    x2: -1971.14,
    y2: -3317.73,
    gradientTransform: "translate(-160794.93 632121.54) rotate(45) scale(168.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#e58582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#e58582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#bd8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd8383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -1972.14,
    y1: -3317.73,
    x2: -1971.14,
    y2: -3317.73,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M350.85,116.15h-3.84v8.12h-1.91v-19.04h5.75c4.41,0,6.43,2.34,6.43,5.47s-1.96,5.45-6.43,5.45Zm0-1.63c3.21,0,4.47-1.47,4.47-3.81s-1.25-3.87-4.47-3.87h-3.84v7.68h3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M362.39,124.26h-1.91v-14.87h1.91v2.64c.82-1.83,2.53-2.91,5.09-2.91v1.99h-.52c-2.48,0-4.58,1.12-4.58,4.85v8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M376.88,124.48c-4.19,0-7.38-2.94-7.38-7.65s3.27-7.65,7.44-7.65,7.44,2.91,7.44,7.65-3.3,7.65-7.49,7.65Zm0-1.66c2.81,0,5.53-1.91,5.53-5.99s-2.67-5.99-5.5-5.99-5.47,1.91-5.47,5.99,2.61,5.99,5.45,5.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "403 107.24 403 113.37 409.07 113.37 409.07 115 403 115 403 121.13 401.23 121.13 401.23 115 395.18 115 395.18 113.37 401.23 113.37 401.23 107.24 403 107.24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.17,77.85h-28.65l-4.11,7.86c-1.5,2.73-2.94,3.76-5.2,3.76-2.49,.04-4.54-1.95-4.58-4.44h0c.07-1.22,.45-2.4,1.1-3.42l18.8-35.56c2.8-5.13,5.47-5.81,8.34-5.81s5.41,.68,8.27,5.81l18.94,35.56c.62,1.04,.97,2.21,1.02,3.42,0,2.46-2,4.45-4.46,4.44h-.05c-2.26,0-3.76-.96-5.26-3.76l-4.17-7.86Zm-23.93-8.89h19.27l-9.64-18.39-9.63,18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.94,84.68c0,2.64-2.14,4.79-4.79,4.79s-4.79-2.14-4.79-4.79V50.16c0-8.41,2.53-9.23,9.57-9.23h20.51c9.51,0,16.07,5.88,16.07,15.38,.15,6.49-4.08,12.28-10.32,14.08l8.41,10.19c1.3,1.22,2.11,2.87,2.26,4.65-.1,2.43-2.15,4.32-4.58,4.24-1.78,0-3.22-.62-5.26-3.21l-11.42-14.57h-15.66v12.99Zm19.83-34.87h-18.46c-1.37,0-1.37,.69-1.37,2.05v10.94h19.83c5.26,0,7.18-2.6,7.18-6.5s-1.91-6.5-7.18-6.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.61,84.68c.02,2.64-2.11,4.8-4.75,4.82-2.64,.02-4.8-2.11-4.82-4.75v-16.47l-21.33-19.69c-1-.91-1.6-2.2-1.64-3.55-.13-2.52,1.81-4.66,4.33-4.79,.17,0,.34,0,.52,0,1.35,.03,2.62,.6,3.55,1.57l19.35,17.98,19.35-17.98c.93-.97,2.21-1.54,3.55-1.57,2.52-.16,4.69,1.75,4.85,4.27,.01,.17,.01,.34,0,.52-.05,1.36-.64,2.64-1.64,3.55l-21.33,19.69v16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M397.11,77.85h-28.65l-4.11,7.86c-1.51,2.73-2.94,3.76-5.19,3.76-2.49,.04-4.54-1.95-4.58-4.44h0c.07-1.22,.45-2.4,1.09-3.42l18.81-35.56c2.8-5.13,5.47-5.81,8.34-5.81s5.4,.68,8.27,5.81l18.94,35.56c.62,1.03,.98,2.21,1.03,3.42,0,2.46-2,4.45-4.45,4.44h-.06c-2.26,0-3.76-.96-5.27-3.76l-4.17-7.86Zm-23.93-8.89h19.28l-9.64-18.39-9.64,18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M39.35,100.32l-.16-.16,.05-.11,33.16-33.04h.23l11.09,10.59,.05,.14-.09,.12-44.26,22.44-.07,.02m-2.14,.12h-.06l-.1-.16V33.4c0-.09,.07-.16,.16-.16h0l.11,.04,34.28,32.72,.05,.11-.05,.12-34.27,34.16-.12,.05M108.76,0H25.91C11.6,0,0,11.6,0,25.91V108.76c0,14.31,11.6,25.91,25.91,25.91H108.76c14.31,0,25.91-11.6,25.91-25.91V25.91c0-14.31-11.6-25.91-25.91-25.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "72.52 67.34 40.19 99.54 83.33 77.66 72.52 67.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40.19,99.54l32.33-32.21,10.81,10.32-43.14,21.89m32.44-32.54h-.23l-33.16,33.04-.05,.11,.16,.16,.07-.02,44.26-22.44,.09-.12-.05-.14-11.09-10.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-8",
    points: "37.37 33.78 37.37 99.89 71.25 66.13 37.37 33.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.37,99.89V33.78l33.88,32.35-33.88,33.76m-.16-66.65c-.09,0-.16,.07-.16,.16V100.28l.1,.15h.06l.12-.04,34.27-34.16,.05-.12-.05-.11L37.32,33.29l-.11-.04h0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.99 33.14 84.95 77.01 105.21 66.74 38.99 33.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.95,77.18l-.11-.05L38.87,33.25v-.23l.18-.03,66.23,33.6,.07,.22-.07,.07-20.26,10.28-.08,.02ZM39.89,33.78l45.09,43.04,19.87-10.08L39.89,33.78Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAryaProPlus);
export default __webpack_public_path__ + "static/media/arya-pro-plus.5de2b93602e0f5de856d4f6af0114e22.svg";
export { ForwardRef as ReactComponent };